import { Form } from '@ant-design/compatible';
import { TabFormFields } from './FormListTab';

export const formFieldUtils = {
  changeValueToField: <FieldsValue extends { id: number }>(value: FieldsValue): TabFormFields<FieldsValue> =>
    Object.entries(value).reduce((prev, curr) => {
      const key = curr[0];
      const value = curr[1];

      return {
        ...prev,
        [key]: key === 'id' ? value : Form.createFormField({ value }),
      };
    }, {} as TabFormFields<FieldsValue>),
  changeFieldToValue: <FieldsValue extends { id: number }>(field: TabFormFields<FieldsValue>): FieldsValue =>
    Object.entries(field).reduce((prev, curr) => {
      const key = curr[0];
      const field = curr[1];

      return {
        ...prev,
        [key]: key === 'id' ? field : field.value,
      };
    }, {} as FieldsValue),
};
